import { encode } from "js-base64";
export const retrieveBorderSvg = (borderColor, isError) => {
    return encode(`<svg preserveAspectRatio="none" viewBox="0 0 494 263" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M409.551 234.093C366.809 267.86 8.53846 249.371 8.53846 249.371L8.54302 8.7905L478.508 8.79053C478.508 8.79053 485.683 128.013 485.456 249.375L405.184 249.375" stroke="${isError ? "#ac0000" : borderColor !== null && borderColor !== void 0 ? borderColor : "#B5C9FF"}" stroke-width="16" stroke-linecap="square" />
        </svg>`);
};
//# sourceMappingURL=utils.js.map